<template>
  <div class="admin-permission-container">
    <div class="admin-permission-content">
      <div class="admin-permission-header">
        <h2>权限设置</h2>
        <p>配置不同角色和权限组的访问权限</p>
      </div>

      <div class="role-tabs">
        <el-tabs v-model="activeTab" type="card">
          <el-tab-pane label="角色权限" name="roles"></el-tab-pane>
          <el-tab-pane label="权限组" name="groups"></el-tab-pane>
          <el-tab-pane label="操作日志" name="logs"></el-tab-pane>
        </el-tabs>
      </div>

      <!-- 角色权限 -->
      <div v-show="activeTab === 'roles'" class="tab-content">
        <el-table :data="rolesList" style="width: 100%" v-loading="loading">
          <el-table-column prop="role" label="角色" width="150">
            <template slot-scope="scope">
              <el-tag :type="getRoleType(scope.row.role)" size="medium">
                {{ scope.row.name }}
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column prop="description" label="描述" width="200"></el-table-column>
          <el-table-column label="权限列表" min-width="300">
            <template slot-scope="scope">
              <el-tag v-for="perm in scope.row.permissions" :key="perm" size="mini" style="margin-right: 4px; margin-bottom: 4px;">
                {{ getPermissionLabel(perm) }}
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column prop="adminCount" label="管理员数" width="100"></el-table-column>
          <el-table-column label="操作" width="120">
            <template slot-scope="scope">
              <el-button size="mini" @click="editRole(scope.row)" :disabled="scope.row.role === 'super_admin'">编辑</el-button>
            </template>
          </el-table-column>
        </el-table>

        <el-dialog title="编辑角色权限" :visible.sync="roleDialogVisible" width="600px">
          <el-form :model="roleForm" label-width="100px">
            <el-form-item label="角色名称">
              <el-input v-model="roleForm.name" disabled></el-input>
            </el-form-item>
            <el-form-item label="描述">
              <el-input v-model="roleForm.description" type="textarea" :rows="2"></el-input>
            </el-form-item>
            <el-form-item label="权限配置">
              <el-checkbox-group v-model="roleForm.permissions">
                <div class="permission-grid">
                  <el-checkbox v-for="perm in allPermissions" :key="perm.value" :label="perm.value">
                    {{ perm.label }}
                  </el-checkbox>
                </div>
              </el-checkbox-group>
            </el-form-item>
          </el-form>
          <div slot="footer">
            <el-button @click="roleDialogVisible = false">取消</el-button>
            <el-button type="primary" @click="saveRole" :loading="savingRole">保存</el-button>
          </div>
        </el-dialog>
      </div>

      <!-- 权限组 -->
      <div v-show="activeTab === 'groups'" class="tab-content">
        <div class="groups-header">
          <el-button type="primary" @click="showAddGroupDialog">添加权限组</el-button>
        </div>

        <el-table :data="permissionGroups" style="width: 100%" v-loading="loadingGroups">
          <el-table-column prop="name" label="权限组名称" width="180"></el-table-column>
          <el-table-column prop="description" label="描述" width="250"></el-table-column>
          <el-table-column label="包含权限" min-width="300">
            <template slot-scope="scope">
              <el-tag v-for="perm in scope.row.permissions" :key="perm" size="mini" style="margin-right: 4px; margin-bottom: 4px;">
                {{ getPermissionLabel(perm) }}
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column prop="memberCount" label="成员数" width="100"></el-table-column>
          <el-table-column label="操作" width="150">
            <template slot-scope="scope">
              <el-button size="mini" @click="editGroup(scope.row)">编辑</el-button>
              <el-button size="mini" type="danger" @click="deleteGroup(scope.row)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>

        <el-dialog :title="groupDialogTitle" :visible.sync="groupDialogVisible" width="600px">
          <el-form :model="groupForm" label-width="100px">
            <el-form-item label="权限组名称">
              <el-input v-model="groupForm.name" placeholder="请输入权限组名称"></el-input>
            </el-form-item>
            <el-form-item label="描述">
              <el-input v-model="groupForm.description" type="textarea" :rows="2" placeholder="请输入权限组描述"></el-input>
            </el-form-item>
            <el-form-item label="权限配置">
              <el-checkbox-group v-model="groupForm.permissions">
                <div class="permission-grid">
                  <el-checkbox v-for="perm in allPermissions" :key="perm.value" :label="perm.value">
                    {{ perm.label }}
                  </el-checkbox>
                </div>
              </el-checkbox-group>
            </el-form-item>
          </el-form>
          <div slot="footer">
            <el-button @click="groupDialogVisible = false">取消</el-button>
            <el-button type="primary" @click="saveGroup" :loading="savingGroup">保存</el-button>
          </div>
        </el-dialog>
      </div>

      <!-- 操作日志 -->
      <div v-show="activeTab === 'logs'" class="tab-content">
        <div class="logs-filter">
          <el-form :inline="true" size="small">
            <el-form-item label="管理员">
              <el-select v-model="logFilter.admin" placeholder="全部" clearable>
                <el-option label="admin" value="admin"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="操作类型">
              <el-select v-model="logFilter.type" placeholder="全部" clearable>
                <el-option label="登录" value="login"></el-option>
                <el-option label="创建" value="create"></el-option>
                <el-option label="修改" value="update"></el-option>
                <el-option label="删除" value="delete"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="loadLogs">查询</el-button>
            </el-form-item>
          </el-form>
        </div>

        <el-table :data="operationLogs" style="width: 100%" v-loading="loadingLogs">
          <el-table-column prop="id" label="ID" width="80"></el-table-column>
          <el-table-column prop="admin" label="管理员" width="120"></el-table-column>
          <el-table-column prop="action" label="操作" width="150"></el-table-column>
          <el-table-column prop="target" label="目标" width="200"></el-table-column>
          <el-table-column prop="ip" label="IP地址" width="150"></el-table-column>
          <el-table-column prop="created_at" label="时间" width="180"></el-table-column>
          <el-table-column label="详情" min-width="150">
            <template slot-scope="scope">
              <el-button size="mini" @click="showLogDetail(scope.row)">查看</el-button>
            </template>
          </el-table-column>
        </el-table>

        <div class="pagination-container">
          <el-pagination
            background
            layout="prev, pager, next"
            :total="logTotal"
            :page-size="20"
            @current-change="handleLogPageChange">
          </el-pagination>
        </div>

        <el-dialog title="操作详情" :visible.sync="logDetailVisible" width="500px">
          <pre class="log-detail">{{ JSON.stringify(currentLog, null, 2) }}</pre>
          <div slot="footer">
            <el-button @click="logDetailVisible = false">关闭</el-button>
          </div>
        </el-dialog>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AdminPermission',
  data() {
    return {
      activeTab: 'roles',
      loading: false,
      loadingGroups: false,
      loadingLogs: false,
      rolesList: [],
      permissionGroups: [],
      operationLogs: [],
      logTotal: 0,
      logFilter: {
        admin: '',
        type: ''
      },
      roleDialogVisible: false,
      roleForm: {
        role: '',
        name: '',
        description: '',
        permissions: []
      },
      savingRole: false,
      groupDialogVisible: false,
      groupForm: {
        id: null,
        name: '',
        description: '',
        permissions: []
      },
      savingGroup: false,
      logDetailVisible: false,
      currentLog: {},
      allPermissions: [
        { value: 'user_manage', label: '用户管理' },
        { value: 'content_manage', label: '内容管理' },
        { value: 'order_manage', label: '订单管理' },
        { value: 'system_setting', label: '系统设置' },
        { value: 'model_manage', label: '模型管理' },
        { value: 'subscription_manage', label: '订阅管理' },
        { value: 'payment_setting', label: '支付设置' },
        { value: 'view_stats', label: '查看统计' },
        { value: 'admin_manage', label: '管理员管理' },
        { value: 'attachment_manage', label: '附件管理' },
        { value: 'generate_manage', label: '生成管理' },
        { value: 'ad_manage', label: '广告管理' }
      ]
    }
  },
  computed: {
    groupDialogTitle() {
      return this.groupForm.id ? '编辑权限组' : '添加权限组'
    }
  },
  mounted() {
    this.loadRoles()
    this.loadGroups()
    this.loadLogs()
  },
  methods: {
    async loadRoles() {
      this.loading = true
      try {
        const res = await this.$axios.get('/admin/permissions/roles')
        if (res.data.code === 200) {
          this.rolesList = res.data.data
        }
      } catch (err) {
        this.rolesList = [
          {
            role: 'super_admin',
            name: '超级管理员',
            description: '拥有所有权限',
            permissions: this.allPermissions.map(p => p.value),
            adminCount: 1
          },
          {
            role: 'admin',
            name: '普通管理员',
            description: '基础管理权限',
            permissions: ['user_manage', 'content_manage', 'view_stats'],
            adminCount: 0
          }
        ]
      } finally {
        this.loading = false
      }
    },
    async loadGroups() {
      this.loadingGroups = true
      try {
        const res = await this.$axios.get('/admin/permissions/groups')
        if (res.data.code === 200) {
          this.permissionGroups = res.data.data
        }
      } catch (err) {
        this.permissionGroups = []
      } finally {
        this.loadingGroups = false
      }
    },
    async loadLogs() {
      this.loadingLogs = true
      try {
        const params = {}
        if (this.logFilter.admin) params.admin = this.logFilter.admin
        if (this.logFilter.type) params.type = this.logFilter.type
        const res = await this.$axios.get('/admin/permissions/logs', { params })
        if (res.data.code === 200) {
          this.operationLogs = res.data.data.list
          this.logTotal = res.data.data.total
        }
      } catch (err) {
        this.operationLogs = [
          { id: 1, admin: 'admin', action: 'login', target: '后台登录', ip: '127.0.0.1', created_at: '2024-05-18 10:00:00' },
          { id: 2, admin: 'admin', action: 'update', target: '系统设置', ip: '127.0.0.1', created_at: '2024-05-18 09:30:00' }
        ]
        this.logTotal = 2
      } finally {
        this.loadingLogs = false
      }
    },
    editRole(role) {
      this.roleForm = {
        role: role.role,
        name: role.name,
        description: role.description,
        permissions: [...role.permissions]
      }
      this.roleDialogVisible = true
    },
    async saveRole() {
      this.savingRole = true
      try {
        const res = await this.$axios.put(`/admin/permissions/roles/${this.roleForm.role}`, {
          description: this.roleForm.description,
          permissions: this.roleForm.permissions
        })
        if (res.data.code === 200) {
          this.$message.success('角色权限保存成功')
          this.roleDialogVisible = false
          this.loadRoles()
        }
      } catch (err) {
        this.$message.error('保存失败')
      } finally {
        this.savingRole = false
      }
    },
    showAddGroupDialog() {
      this.groupForm = {
        id: null,
        name: '',
        description: '',
        permissions: []
      }
      this.groupDialogVisible = true
    },
    editGroup(group) {
      this.groupForm = {
        id: group.id,
        name: group.name,
        description: group.description,
        permissions: [...group.permissions]
      }
      this.groupDialogVisible = true
    },
    async saveGroup() {
      if (!this.groupForm.name) {
        this.$message.warning('请输入权限组名称')
        return
      }
      this.savingGroup = true
      try {
        let res
        if (this.groupForm.id) {
          res = await this.$axios.put(`/admin/permissions/groups/${this.groupForm.id}`, this.groupForm)
        } else {
          res = await this.$axios.post('/admin/permissions/groups', this.groupForm)
        }
        if (res.data.code === 200) {
          this.$message.success(this.groupForm.id ? '修改成功' : '添加成功')
          this.groupDialogVisible = false
          this.loadGroups()
        }
      } catch (err) {
        this.$message.error('保存失败')
      } finally {
        this.savingGroup = false
      }
    },
    async deleteGroup(group) {
      try {
        await this.$confirm('确定要删除权限组 ' + group.name + ' 吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
      } catch {
        return
      }
      try {
        const res = await this.$axios.delete(`/admin/permissions/groups/${group.id}`)
        if (res.data.code === 200) {
          this.$message.success('删除成功')
          this.loadGroups()
        }
      } catch (err) {
        this.$message.error('删除失败')
      }
    },
    handleLogPageChange() {
      this.loadLogs()
    },
    showLogDetail(log) {
      this.currentLog = log
      this.logDetailVisible = true
    },
    getRoleType(role) {
      const types = {
        'super_admin': 'danger',
        'admin': 'primary'
      }
      return types[role] || 'info'
    },
    getPermissionLabel(value) {
      const perm = this.allPermissions.find(p => p.value === value)
      return perm ? perm.label : value
    }
  }
}
</script>

<style scoped>
.admin-permission-container {
  padding: 20px 0;
}

.admin-permission-content {
  background: #ffffff;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  padding: 30px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  color: #333;
}

.admin-permission-header {
  margin-bottom: 20px;
}

.admin-permission-header h2 {
  font-size: 24px;
  font-weight: 600;
  color: #333;
  margin-bottom: 8px;
}

.admin-permission-header p {
  font-size: 14px;
  color: #666;
  margin: 0;
}

.role-tabs {
  margin-bottom: 20px;
}

.tab-content {
  padding: 10px 0;
}

.groups-header {
  margin-bottom: 15px;
  text-align: right;
}

.permission-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 10px;
}

.logs-filter {
  margin-bottom: 15px;
  padding: 15px;
  background: #f5f7fa;
  border-radius: 4px;
}

.pagination-container {
  margin-top: 20px;
  text-align: right;
}

.log-detail {
  background: #f5f7fa;
  padding: 15px;
  border-radius: 4px;
  max-height: 400px;
  overflow-y: auto;
  font-size: 12px;
  color: #333;
}

.el-button--primary {
  background: linear-gradient(135deg, #00e6ac, #00cc99);
  border: none;
  color: #000;
  font-weight: 600;
}

.el-button--primary:hover {
  background: linear-gradient(135deg, #00cc99, #00b386);
  color: #000;
}
</style>
